import styled from "styled-components";

export const StyledCreateCumboModal = styled.div`
    width: 100%;
    .tab-wrap {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        @media (max-width: 575px) {
            flex-wrap: wrap;
        }
        li {
            width: 100%;
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
            padding: 10px;
            text-align: center;
            border-bottom: 1px solid rgba(236, 236, 236, 1);
            &.active {
                color: var(--primary);
                border-bottom: 2px solid var(--primary);
            }
        }
    }
    .step-desc {
        display: block;
        text-align: center;
        color: rgba(119, 119, 119, 1);
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        margin-bottom: 20px;
    }
`;
